import styled from "styled-components";

// single source of truth for the read aloud colour, shared by every read aloud
// control (stories, news, quiz options)
export const READ_ALOUD_COLOR = "#432666";
export const READ_ALOUD_BORDER_COLOR = "rgba(108, 48, 135, 0.3)";

export const ReadAloudContainer = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
`;

export const ReadAloudVoiceSelect = styled.select`
  height: 28px;
  width: 100px;
  padding: 0 4px;
  border: 1px solid ${READ_ALOUD_BORDER_COLOR};
  border-radius: 4px;
  background-color: #ffffff;
  color: ${READ_ALOUD_COLOR};
  font-size: var(--xsm-font-size);
  outline: none;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};

  &:disabled {
    opacity: 0.5;
  }
`;

export const ReadAloudIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0;
  border: 1px solid ${READ_ALOUD_BORDER_COLOR};
  border-radius: 100px;
  background-color: ${props => (props.active ? READ_ALOUD_COLOR : "#ffffff")};
  color: ${props => (props.active ? "#ffffff" : READ_ALOUD_COLOR)};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  outline: none;
  transition: all 0.2s;

  i {
    font-size: 13px;
  }

  &:hover {
    background-color: ${props => (props.disabled ? "#ffffff" : READ_ALOUD_COLOR)};
    color: ${props => (props.disabled ? READ_ALOUD_COLOR : "#ffffff")};
  }
`;
